import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from '@sdbn/appclient';
import { environment } from 'src/environments/environment';
import { YardMap } from './yard-map.model';

@Injectable({
  providedIn: 'root'
})
export class YardMapService {

  constructor(private httpService: HttpService) { }

  public getYardMap(mapName: string): Observable<YardMap> {
    return this.httpService.postWithContext(environment.yardMapEndpoint, mapName);
  }

}
